export const SHOW_EVENT_DATE_AS_TBD = true;

export const EVENT_DATE_TBD_TEXT = 'TBD';
